var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var UpdateError;
(function (UpdateError) {
})(UpdateError || (UpdateError = {}));
var UpdateRequest = /** @class */ (function () {
    function UpdateRequest(updates) {
        this.knownErrorCodes = Object.values(UpdateError);
        this.method = 'post';
        this.path = 'my/tags-blacklist';
        this.body = JSON.stringify(updates.map(function (_a) {
            var blacklist = _a.blacklist, tag = _a.tag;
            return (__assign(__assign({}, tag), { blacklist: blacklist }));
        }));
    }
    return UpdateRequest;
}());
export { UpdateRequest };
